import { Injectable } from '@angular/core';
import {catchError, Observable, retry} from "rxjs";
import {TermsModel} from "../models-otc/terms-model";
import {CropsModel} from "../models-otc/crops-model";
import { HttpClient, HttpParams } from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HelperService} from "../../helper.service";
import {BaseService} from "../../services/base.service";
import { OrderSuffixModel } from '../models-otc/order-suffix-model';

@Injectable({
    providedIn: 'root'
})
export class MetadataService extends BaseService{

    constructor(
        private httpClient: HttpClient,
        public snackBar: MatSnackBar,
        public helper: HelperService,
    ) {
        super();
    }

    /// GET ///
    getTermsList(): Observable<TermsModel[]> {
        return this.httpClient.get<TermsModel[]>(this.OTC_BASE_URL + 'paymentterms')
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Terms List','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    getCropsList(): Observable<CropsModel[]> {
        return this.httpClient.get<CropsModel[]>(this.OTC_BASE_URL + 'crops')
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Crops List','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

        getOrderSuffixList(date?:string): Observable<OrderSuffixModel[]> {
        const params = new HttpParams().set('date', date);

        return this.httpClient.get<OrderSuffixModel[]>(this.OTC_BASE_URL + 'suffix/valid', {params})
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Suffix List','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }
}
